<template>
  <div class="scence">
    <div class="container">
      <el-tabs v-model="activeName" @tab-click="tabClick">
        <el-tab-pane label="面雨量" :name="collocationType[0].value">
          <div class="query_and_btn">
            <div>
              <span>区域名称：</span>
                <el-select v-model="query.rainID" clearable placeholder="请选择" @change="changeArealRainfall">
                  <el-option
                    v-for="item in arealRainfalls"
                    :key="item.id"
                    :label="item.arealRainfallName"
                    :value="item.id">
                  </el-option>
                </el-select>
              <span class="add" @click="add"><span class="add-icon"></span>新增</span>
              <span class="edit" @click="edit"><span class="edit-icon"></span>编辑</span>
              <span class="save"  @click="save(collocationType[0])"><span class="add-icon"></span>保存配置</span>

            </div>
          </div>
          <div>
            <div>
              <div>
                <div>站点</div>
                <div>
                  <el-select v-model="query.addvcd" :clearable="true" placeholder="请选择">
                    <el-option
                      v-for="(item,index) in adcds"
                      :key="index"
                      :label="item.adnm"
                      :value="item.adcd"
                    ></el-option>
                  </el-select>
                  <el-button @click="getStationBaseList" type="primary" icon="el-icon-search">搜索</el-button>
                </div>
              </div>
              <div>
                <div ref="table1">
                  <el-table
                    :data="tableData1"
                    border
                    :height="tableHeight1"
                    @selection-change="selectionChangeTable1"
                  >
                    <el-table-column type="selection" min-width="30"></el-table-column>
                    <el-table-column prop="stlc" label="乡镇" min-width="50"></el-table-column>
                    <el-table-column prop="stnm" label="名称" min-width="50"></el-table-column>
                  </el-table>
                </div>
                <pager
                  :pageIndex="query.pageIndex"
                  :pageSize="query.pageSize"
                  :total="query.total"
                ></pager>
              </div>
            </div>
            <div>
              <div @click="select">
                <el-button
                  icon="el-icon-d-arrow-right"
                  size="large"
                  type="primary"
                  :disabled="tableDataSelect1.length<=0"
                >选中</el-button>
              </div>
              <div  @click="cancel">
                <el-button
                  icon="el-icon-d-arrow-left"
                  size="large"
                  type="primary"
                  :disabled="tableDataSelect2.length<=0"
                >取消</el-button>
              </div>
            </div>
            <div>
              <div>已选择站点</div>
              <div ref="table2">
                <el-table
                  :data="tableData2"
                  border
                  :height="tableHeight1"
                >
                  <el-table-column type="selection" min-width="30"></el-table-column>
                  <el-table-column prop="stlc" label="乡镇" min-width="50"></el-table-column>
                  <el-table-column prop="stnm" label="名称" min-width="50"></el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <dataForm ref="dataForm" @getData="getArealRainfallList"></dataForm>
  </div>
</template>

<script>
import monitorType from '@/store/types/monitor'
import usercenterType from '@/store/types/usercenter'
import Pager from '@/components/Pager'
import dataForm from './dataForm'

export default {
  components: {
    Pager,
    dataForm
  },
  data () {
    return {
      tableData1: [],
      tableData2: [],
      tableDataSelect1: [],
      tableDataSelect2: [],
      activeName: '',
      query: {
        pageIndex: 1,
        pageSize: 500,
        sid: 3,
        isRain: true,
        rainID: ''
      },
      collocationType: [
        { name: '面雨量配置', value: '1' },
        { name: '降雨等值面配置', value: '2' }
      ],
      adcds: [],
      tableHeight1: 400,
      arealRainfalls: []
    }
  },
  methods: {
    selectionChangeTable1 (val) {
      this.tableDataSelect1 = Object.assign([], val)
    },
    selectionChangeTable2 (val) {
      this.tableDataSelect2 = Object.assign([], val)
    },
    add () {
      this.$refs['dataForm'].isShow = true
      this.Global.clearValidate(this.$refs['dataForm'], 'form')
      this.$refs['dataForm'].form = { isDisplay: false, sid: this.query.sid }
    },
    edit () {
      console.log(111)
      if (this.query.rainID) {
        this.$refs['dataForm'].isShow = true
        let result = this.arealRainfalls.find(f => {
          return f.id === this.query.rainID
        })
        this.$refs['dataForm'].form = Object.assign({}, result)
        this.Global.clearValidate(this.$refs['dataForm'], 'form')
      } else {
        this.$notify({
          title: '警告',
          message: '请先选择一个区域名称',
          type: 'warning'
        })
      }
    },
    tabClick () {
      this.tableDataSelect1 = []
      this.tableDataSelect2 = []
      this.tableData1 = []
      this.tableData2 = []
      this.query.addvcd = ''
      this.query.rainID = ''
      this.query.pageIndex = 1
      this.getStationBaseList()
      let result = this.collocationType.find(f => { return f.value === this.activeName })
      this.getConfiguredArealRainfallStation(result)
    },
    async save (val) {
      let form = { sid: this.query.sid, collocationType: val.value }
      if (val.value === this.collocationType[0].value) {
        if (this.query.rainID) {
          form.rainID = this.query.rainID
        } else {
          this.$notify({
            title: '警告',
            message: '区域名称不能为空',
            type: 'warning'
          })
          return false
        }
      }
      if (this.tableData2.length > 0) {
        let stids = []
        this.tableData2.forEach(f => {
          stids.push(f.id)
        })
        form.stid = stids.join(',')
      } else {
        this.$notify({
          title: '警告',
          message: '已选择站点不能为空',
          type: 'warning'
        })
        return false
      }
      let result = await this.$store.dispatch(
        usercenterType.postCollocationStationInfo,
        form
      )
      if (result.isSuccess) {
        this.$notify.success({ title: '成功', message: '保存成功' })
      } else {
        this.$notify.error({ title: '失败', message: '保存失败' })
      }
    },
    async getAdcd () {
      let query = Object.assign({}, this.query)
      query.isTown = true
      let result = await this.$store.dispatch(monitorType.GET_ADCD, query)
      this.adcds = result.results
    },
    async getStationBaseList () {
      let query = Object.assign({}, this.query)
      if (query.addvcd) {
        query.addvcd = query.addvcd.substr(0, 9)
      }
      let result = await this.$store.dispatch(
        usercenterType.getStationBaseList,
        query
      )
      if (result) {
        let tableData1 = result.rows
        this.query.total = result.total
        let removeData = []
        tableData1.forEach((f, index) => {
          let result = this.tableData2.findIndex(ff => {
            return ff.id === f.id
          })
          if (result !== -1) {
            removeData.push(f)
          }
        })
        removeData.forEach(f => {
          let result = tableData1.findIndex(ff => {
            return f.id === ff.id
          })
          tableData1.splice(result, 1)
        })
        this.tableData1 = tableData1
      }
    },
    async getArealRainfallList () {
      let result = await this.$store.dispatch(
        usercenterType.getArealRainfallList,
        this.query
      )
      if (result) {
        this.arealRainfalls = result.rows
      }
    },
    async getConfiguredArealRainfallStation (val) {
      let query = Object.assign({}, this.query)
      query.collocationType = val.value
      let result = await this.$store.dispatch(
        usercenterType.getConfiguredArealRainfallStation,
        query
      )
      if (result) {
        this.tableData2 = result.rows
        this.tableData2.forEach(f => {
          let result = this.tableData1.findIndex(ff => {
            return ff.id === f.id
          })
          if (result !== -1) {
            this.tableData1.splice(result, 1)
          }
        })
      }
    },
    select () {
      this.tableDataSelect1.forEach(f => {
        let result = this.tableData1.findIndex(ff => {
          return ff.id === f.id
        })
        if (result !== -1) {
          this.tableData1.splice(result, 1)
        }
        result = this.tableData2.findIndex(ff => {
          return ff.id === f.id
        })
        if (result === -1) {
          this.tableData2.push(f)
        }
      })
      this.tableDataSelect1 = []
    },
    cancel () {
      this.tableDataSelect2.forEach(f => {
        let result = this.tableData2.findIndex(ff => {
          return ff.id === f.id
        })
        if (result !== -1) {
          this.tableData2.splice(result, 1)
        }
        result = this.tableData1.findIndex(ff => {
          return ff.id === f.id
        })
        if (result === -1) {
          this.tableData1.push(f)
        }
      })
      this.tableDataSelect2 = []
    },
    changeArealRainfall (val) {
      this.tableDataSelect1 = []
      this.tableDataSelect2 = []
      this.getConfiguredArealRainfallStation(this.collocationType[0])
    }
  },
  created () {
    this.activeName = this.collocationType[0].value
    this.getAdcd()
    this.getStationBaseList()
    this.getArealRainfallList()
  },
  mounted () {
    // this.$nextTick(() => {
    //   let elTabsContent = document.getElementsByClassName(
    //     'el-tabs__content'
    //   )[0]
    //   console.log(elTabsContent)
    //   let elTabsContentXy = elTabsContent.getBoundingClientRect()
    //   console.log(elTabsContentXy)
    //   elTabsContent.style.height = `${document
    //     .getElementsByClassName('refline')[0]
    //     .getBoundingClientRect().y - elTabsContentXy.y}px`
    //   this.tableHeight1 = `${document
    //     .getElementsByClassName('refline1')[0]
    //     .getBoundingClientRect().y -
    //     this.$refs['table1'].getBoundingClientRect().y}px`
    // })
  }
}
</script>
<style lang="less" src="@/assets/usercenter.less" scoped></style>
<style lang="less" scoped>
.container {
  margin-top: 10px;
  & > div {
    margin-left: 10px;
    margin-right: 10px;
  }
  /deep/ .el-tabs {
    background-color: #fff;
    padding-left: 10px;
    padding-right: 10px;
    .el-tab-pane {
      & > div:nth-child(2) {
        display: flex;
        & > div:nth-child(1),
        & > div:nth-child(3) {
          width: 830px;
          & > div:nth-child(1) {
            margin-bottom: 5px;
            height: 40px;
          }
          /deep/ .el-table {
            padding: 2px;
          }
        }
        & > div:nth-child(2) {
          width: 215px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 500px;
          & > div:nth-of-type(n + 1) {
            margin-top: 10px;
          }
        }
        & > div:nth-child(1),
        & > div:nth-child(3) {
          & > div:nth-child(1) {
            font-size: 18px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            & > div:nth-child(2) {
              & > div:nth-child(1) {
                margin-right: 10px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
